/**
 * useInAppView
 */

import { useAppView, useMediaConfig } from '../config';

const useInAppView = (key) => {

    const appView = useAppView();
    const { excludedAppViews = {} } = useMediaConfig();
    const keysArray = Array.isArray(key) ? key : [key];

    return keysArray.map(k => {

        const excludedViews = excludedAppViews[k] || [];
        return !excludedViews.includes(appView);

    });

};

export default useInAppView;
